export default __webpack_public_path__ + "static/media/photo--lg--8.a6c5bb39.jpg";